import Team from './Team'
import Checkout from './Checkout/index'
import Impact from './Impact/index'
import Root from './Root/index'
import FunderDashboard from './FunderDashboard/index'
import Academy from './Academy/index'
import Coaching from './Coaching/index'
import Settings from './Settings/index'
import Upgrade from './Upgrade/index'
import Fundraising from './Fundraising/index'
import Services from './Services/index'
import UpgradeLanding from './Upgrade/UpgradeLanding/index'
import SignupLanding from './Signup/index'
import DonationPortal from './DonationPortal/index'
import Home from './Home/index'
import Welcome, {
  OnBoarding,
  CheckInSurvey,
  NeedsAssessment,
  Intake,
} from './Welcome'
import { Community } from './Community'
import NoAccountFound from './NoAccountFound/index'
import { RESILIA_PRICING_URL } from './Checkout/content'
import NoAccessPage from './NoAccess/index'
import SelfServe from './SelfServe/index'

const PricingRedirect = () => {
  window.location.assign(RESILIA_PRICING_URL)
  return null
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const Pricing = {
  path: '/pricing',
  exact: false,
  Component: PricingRedirect,
  access: 'PUBLIC',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const Routes = [
  Academy,
  OnBoarding,
  CheckInSurvey,
  Checkout,
  Coaching,
  Community,
  DonationPortal,
  Home,
  Impact,
  FunderDashboard,
  Fundraising,
  Intake,
  NeedsAssessment,
  NoAccountFound,
  NoAccessPage,
  Pricing,
  Root,
  SelfServe,
  Services,
  Settings,
  SignupLanding,
  Team,
  Upgrade,
  UpgradeLanding,
  Welcome,
]

export default Routes
